import React from 'react';
import { useShowContextRequired } from 'ui-builder';
import { Project, TotalTasks } from 'nekst-api';
import useFeatureToggleService from 'feature-toggle';
import { TooltipBadgeGroup } from 'shadcn-ui';

import styles from './TotalTasksField.module.scss';
import { useProjectStatisticContextRequired } from 'features/tasks-forms';

function ShadcnTotalTasksLayout(props: { value: TotalTasks }) {
  return (
    <TooltipBadgeGroup
      badges={[
        {
          value: props.value.active,
          tooltip: 'Total Tasks Due Today',
          className: 'text-green-700 bg-green-50/50',
        },
        {
          value: props.value.pastDue,
          tooltip: 'Total Past Due Tasks',
          className: 'text-rose-700 bg-rose-50/50',
        },
        {
          value: props.value.all,
          tooltip: 'Total Tasks Upcoming',
          className: 'text-sky-600 bg-sky-50/50',
        },
      ]}
    />
  );
}

function LegacyTotalTasksLayout(props: { value: TotalTasks }) {
  return (
    <div className={styles.field}>
      <span className={styles.active} title="Total Tasks Due Today">{props.value.active}</span>
      {' / '}
      <span className={styles.pastDue} title="Total Past Due Tasks">{props.value.pastDue}</span>
      {' / '}
      <span title="Total Tasks Upcoming">{props.value.all}</span>
    </div>
  );
}

function TotalTasksLayout(props: { value: TotalTasks }) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnTotalTasksLayout value={props.value} />;
  } else {
    return <LegacyTotalTasksLayout value={props.value} />;
  }
}

export function StatisticTotalTasks() {
  const statistic = useProjectStatisticContextRequired().statistic;

  if (statistic) {
    return (
      <TotalTasksLayout value={statistic.totalTasks} />
    );
  } else {
    return null;
  }

}

export default function TotalTasksField(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,react/no-unused-prop-types
  props: { label: string },
) {
  const showContext = useShowContextRequired<Project>();

  const value = showContext.data.statistic?.totalTasks;

  if (value) {
    return (
      <TotalTasksLayout value={value} />
    );
  } else {
    return null;
  }
}
